<template>
    <v-app class="homepage osago-company-page">
        <div class="homepage__container homepage__white">
            <v-container class="osago-company-page">
                <v-layout wrap class="osago-company-page__layout">
                    <v-flex xs12 md6 class="osago-company-page__header">
                        <h1>
                            Наша цель —
                            ваше удобство
                            и комфорт
                        </h1>
                        <v-flex class="osago-company-page__header__links">
                            <a @click="goToElement('contact-us')">Как с нами связаться</a>
                            <a @click="goToElement('requisites')">Реквизиты</a>
                        </v-flex>
                    </v-flex>
                    <v-flex xs12 md6 class="osago-company-page__body">
                        <p>Getpolis.ru — это сайт на котором Вы сможете удобно и быстро рассчитать, сравнить и купить понравившийся страховой полис онлайн. Заполнив короткую анкету, вы получите предложения ведущих страховых компаний и сами выберете подходящее.</p>
                        <p>Мы создали наш сайт для того, чтобы в поисках лучшего предложения Вам не приходилось ездить по городу из одной страховой компании в другую или тратить время на звонки, не приходилось рассчитывать на честность и расторопность страхового агента. Мы предлагаем простой и прозрачный сервис, на котором Вы в одном месте получите и сравните предложения ведущих страховых компаний и, не выходя из дома, приобретете подходящий страховой полис.</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container homepage__mobile-grey">
            <v-container class="homepage__container-why-choose-us" id="chooseContainer">
                <h2>Преимущества</h2>
                <v-flex class="homepage__container-why-choose-us__inner" hidden-sm-and-down>
                    <v-layout wrap row class="homepage__container-why-choose-us__block" hidden-sm-and-down id="choose1" style="top:0px">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Высокая надежность</h4>
                            <p>работаем с ведущими страховыми компаниями</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Нет<br>«подводных камней»</h4>
                            <p>и текста мелким шрифтом под звездочкой</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Мы предлагаем только выбранные нами продукты</h4>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap row class="homepage__container-why-choose-us__block green-gradient" hidden-sm-and-down id="choose2" style="top:563px">
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Удобная навигация</h4>
                            <p>Позволяет быстро найти страховку на одном сайте, подходящую именно вам.</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <h4>Простая система оплаты онлайн</h4>
                            <p>с возможностью получения полиса на почту</p>
                        </v-flex>
                        <v-flex md4 class="homepage__container-why-choose-us__block__column">
                            <img :src="'/img/home/1_2.png'" class="image_2"/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-layout class="homepage__container-why-choose-us__slider" hidden-md-and-up>
                    <v-carousel
                        hide-controls
                    >
                        <v-carousel-item
                            v-for="(slide,i) in slides"
                            :key="i"
                            :interval="3000"
                            :src="slide.url"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        ></v-carousel-item>
                    </v-carousel>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container homepage__white" id="contact-us">
            <v-container class="homepage__how-to-contact">
                <h2>
                    Как с нами связаться
                </h2>
                <v-flex class="under-title">
                    Мы всегда рады ответить на ваши вопросы. <br>Звоните и пишите нам!
                </v-flex>
                <v-layout wrap>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Горячая линия</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">8 800 201 06 43</v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Электронная почта</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info"><a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a></v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Головной офис</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">г. Ростов-на-Дону, <br>ул. Социалистическая, <br>д. 74, оф. 609</v-flex>
                    </v-flex>
                    <v-flex xs12 sm6 md3 class="homepage__how-to-contact__item">
                        <v-flex class="homepage__how-to-contact__item__text">Режим работы</v-flex>
                        <v-flex class="homepage__how-to-contact__item__info">Пн-Пт <br>с 9:00 до 21:00</v-flex>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="homepage__container homepage__white" id="requisites">
            <v-container class="homepage__how-to-contact">
                <h2>
                    Реквизиты
                </h2>
                <v-flex class="under-title">
                    ООО «Гетполис» <br>
                    ОГРН: 1186196044748, ИНН: 6164123789, КПП: 616401001 <br>
                    Адрес: 344002, г. Ростов-на-Дону, ул. Социалистическая, д. 74, оф. 609 <br>
                </v-flex>
            </v-container>
        </div>
    </v-app>
</template>
<script>
    export default {
        data: () => ({
            slides: [
                { url: '/img/home/company_slider/01.jpg' },
                { url: '/img/home/company_slider/02.jpg' },
                { url: '/img/home/company_slider/03.jpg' },
                { url: '/img/home/company_slider/04.jpg' },
                { url: '/img/home/company_slider/05.jpg' },
            ],
        }),

        created: function() {
            this.$nextTick(() => {
                this.chooseScrollListener()
            })
        },

        methods: {
            chooseScrollListener() {
                let choose1 = document.getElementById('choose1')
                let choose2 = document.getElementById('choose2')
                let point
                window.addEventListener('scroll', (e) => {
                    if (window.screen.width > 960) {
                        point = Math.floor(choose2.getBoundingClientRect().top) - 800
                        if (point < 0) {
                            if (point > -100) {
                                choose1.style.position = 'fixed'
                                choose1.style.top = '100px'
                                choose1.style.opacity = 1
                                choose1.style.transform = 'scale(1)'
                            }
                            if (point <= -100 && point > -350) {
                                choose1.style.opacity = 1
                                choose1.style.transform = 'scale(1)'
                            }
                            if (point <= -350 && point > -450) {
                                choose1.style.opacity = 0.9
                                choose1.style.transform = 'scale(0.95)'
                            }
                            if (point <= -450 && point > -550) {
                                choose1.style.opacity = 0.8
                                choose1.style.transform = 'scale(0.9)'
                            }
                            if (point <= -550 && point > -650) {
                                choose1.style.opacity = 0.5
                                choose1.style.transform = 'scale(0.9)'
                            }
                            if (point <= -550) {
                                choose1.style.display = 'none'
                                choose1.style.position = 'fixed'
                                choose1.style.opacity = 0
                                choose1.style.transform = 'scale(0.95)'
                            } else {
                                choose1.style.display = 'flex'
                            }
                        } else {
                            choose1.style.display = 'flex'
                            choose1.style.position = 'absolute'
                            choose1.style.top = '0px'
                            choose1.style.opacity = 1
                            choose1.style.transform = 'scale(1)'
                        }
                    }

                }, false)
            },

            goToElement(elementId) {
                document.getElementById(elementId).scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest"
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/OsagoCompany.vue